import produce from "immer";
import _omit from "lodash/fp/omit";
import { OrderValue, SOR } from "../globalTypes";
import { EMPTY_SOR } from "../globalConsts";

/**
 * Vrátí nový SOR po aplikaci orderu. Výsledný ordery můžou mít díru a kvůli
 * nulám nemusí začínat od 1, ale nejvyšší index by neměl přesáhnout počet záznamů
 */
export const handleOrder = (sor: SOR, colKey: string, newOrder: OrderValue) => {
  const newSor = produce(sor, (draft) => {
    const existingKeys = Object.keys(draft.order).sort((a, b) => {
      const aRank = draft.order[a].rank;
      const bRank = draft.order[b].rank;

      if (aRank > bRank) return 1;
      if (aRank < bRank) return -1;
      return 0;
    });

    const deleteExistingOrder = () => {
      delete draft.order[colKey];
    };

    const addFirstOrder = () => {
      draft.order[colKey] = { order: newOrder, rank: 1 };
    };

    const addNewOrder = () => {
      draft.order[colKey] = { order: newOrder, rank: existingKeys.length + 1 };
    };

    const changeOrderToOpposite = () => {
      draft.order[colKey].order = newOrder;
    };

    const reRankOrders = () => {
      const existingKeysAfterDelete = Object.keys(draft.order);

      if (!existingKeysAfterDelete.length) return;

      const sortedKeys = existingKeysAfterDelete.sort((a, b) => {
        const aRank = draft.order[a].rank;
        const bRank = draft.order[b].rank;

        if (aRank > bRank) return 1;
        if (aRank < bRank) return -1;
        return 0;
      });

      sortedKeys.forEach((key, index) => {
        draft.order[key].rank = index + 1;
      });
    };

    if (!existingKeys.length) {
      addFirstOrder();
      return;
    }

    if (draft.order[colKey]?.order === newOrder) {
      deleteExistingOrder();
      reRankOrders();
      return;
    }

    if (draft.order[colKey] && draft.order[colKey]?.order !== newOrder) {
      changeOrderToOpposite();
      return;
    }

    addNewOrder();
  });

  return newSor;
};

const HIGH_RANK = 100000;
const LOW_RANK = 1;

export const createPresortedSor = (
  sortColumn: string,
  order: OrderValue,
  sor = EMPTY_SOR
) =>
  produce(sor, (draft) => {
    draft.order[sortColumn] = { order, rank: HIGH_RANK };
  });
